module.exports = __webpack_public_path__ + "img/Reimagining_the_Role_of_the_CFO.0d4a363f.jpg";